import React from 'react'

interface TableBodyProps {
  children: React.ReactNode
}

export default function TableBody({ children }: TableBodyProps): JSX.Element {
  return <tbody className="tw-bg-white">{children}</tbody>
}
